import Emitter from 'tiny-emitter';

const emitter = new Emitter();

const emitterHelper = Vue => {
  Object.defineProperties(Vue.config.globalProperties, {
    $emitter: {
      get() {
        return emitter;
      },
    },
  });
};

export default emitterHelper;
